import {
  CalendarBlank,
  Car,
  ChatCircle,
  Clock,
  Envelope,
  MapPin,
  Phone,
  Storefront,
  WhatsappLogo,
} from "@phosphor-icons/react";

export const TILE_ICONS = {
  pin: MapPin,
  phone: Phone,
  envelope: Envelope,
  clock: Clock,
  chat: ChatCircle,
  calendar: CalendarBlank,
  car: Car,
  store: Storefront,
  whatsapp: WhatsappLogo,
};

export const TILE_KINDS = [
  ["address", "Address (from My Company)", "pin", "Visit us"],
  ["phone", "Phone (from My Company)", "phone", "Call us"],
  ["email", "Email (from My Company)", "envelope", "Email us"],
  ["hours", "Opening hours (from My Company)", "clock", "Opening hours"],
  ["custom", "Custom tile", "chat", ""],
];

export const DEFAULT_TILES = ["address", "phone", "email", "hours"].map(
  (kind) => ({ kind, icon: "", label: "", value: "", href: "", show: true }),
);

const digits = (s) => (s || "").replace(/[^\d+]/g, "");

// Turn saved tile rows into what the public page renders, filling blanks from the shop record.
export const resolveTiles = (tiles, shop, contact, hoursLines) => {
  const auto = {
    address: { value: shop.address, label: "Visit us", testId: "contact-office" },
    phone: { value: shop.phone, label: "Call us", testId: "contact-phone" },
    email: { value: shop.email, label: "Email us", testId: "contact-email" },
    hours: {
      value: hoursLines.join("\n"),
      label: contact.hours_label || "Opening hours",
      testId: "contact-hours",
    },
    custom: { value: "", label: "", testId: "" },
  };
  const rows = Array.isArray(tiles) ? tiles : DEFAULT_TILES;
  return rows
    .map((t, i) => {
      if (t.show === false) return null;
      const kind = auto[t.kind] ? t.kind : "custom";
      const base = auto[kind];
      const value = (t.value || "").trim() || base.value;
      if (!value) return null;
      const overridden = !!(t.value || "").trim();
      let href = (t.href || "").trim();
      if (!href) {
        if (kind === "address") href = `https://maps.google.com/?q=${encodeURIComponent(value)}`;
        else if (kind === "phone") href = `tel:${overridden ? digits(value) : shop.phone_link || digits(value)}`;
        else if (kind === "email") href = `mailto:${value}`;
      }
      const kindIcon = TILE_KINDS.find(([k]) => k === kind)?.[2] || "chat";
      return {
        key: `${kind}-${i}`,
        icon: TILE_ICONS[t.icon] || TILE_ICONS[kindIcon],
        label: (t.label || "").trim() || base.label,
        value,
        href,
        testId: base.testId || `contact-tile-${i}`,
      };
    })
    .filter(Boolean);
};
